import { ExpenseByVendorResponse } from "@common/types/reports/types";
import { ExpenseByVendorViewRow } from "./expenseByVendorViewTypes";

/**
 * Converts an ExpenseByVendorResponse into a flat row model for the
 * ViewTable runtime.  No nesting; the synthetic Total row is appended
 * as the last sibling.
 *
 * NOTE: rows are expected to already be sorted by the caller (the page
 * keeps the sort state and pre-sorts via `sortExpenseByVendorRows`).
 */
export function buildExpenseByVendorRows(
    report: ExpenseByVendorResponse,
): ExpenseByVendorViewRow[] {
    const rows: ExpenseByVendorViewRow[] = report.rows.map((row) => ({
        id: `vendor:${row.vendorId ?? row.vendorName}`,
        vendorId: row.vendorId,
        vendorName: row.vendorName,
        values: row.values,
        isSummary: false,
    }));

    rows.push({
        id: "total:expense-by-vendor",
        vendorId: null,
        vendorName: "Total",
        values: report.totals,
        isSummary: true,
    });

    return rows;
}
